import React, {useEffect, useState} from 'react';
import numeral from 'numeral';
import classNames from 'classnames';
import {getMPPEndpoint, getHeaders} from '../../../../../../helpers/endpoint';
import {useDispatch} from 'react-redux';
import Loader from '../../../../../../components/Loader';

export interface IChallengesStats {
  [key: string]: {
    min: number;
    max: number;
    average: number;
    users: number;
  };
}

const ChallengesByUser = () => {
  const dispatch = useDispatch();

  const [lang, setLang] = useState('fr-FR');
  const [stats, setStats] = useState<IChallengesStats | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);

  const getChallengesStats = (onSuccess: (response) => void) => {
    return (_dispatch, getState) => {
      setIsLoading(true);
      return fetch(getMPPEndpoint('getMPPChallengesStats'), {
        method: 'GET',
        headers: getHeaders(getState().authentication),
      })
        .then(response => response.json())
        .then(data => {
          if (data.error) {
          } else {
            onSuccess(data);
            setIsLoading(false);
          }
        })
        .catch(() => {});
    };
  };

  useEffect(() => {
    dispatch(getChallengesStats(response => setStats(response)));
  }, []);

  const renderChallengesByUser = () => {
    let table = stats && stats?.[lang];

    return table ? (
      <div className="mb-4">
        <div className="mt-3 table-responsive">
          <table className="table table-bordered no-margin table-striped">
            <tbody>
              <tr className="text-center">
                <th className="text-left">Min</th>
                <th style={{width: '300px'}} className="text-center">
                  {numeral(table.min).format('0')}
                </th>
              </tr>
              <tr className="text-center">
                <th className="text-left">Max</th>
                <th style={{width: '300px'}} className="text-center">
                  {numeral(table.max).format('0')}
                </th>
              </tr>
              <tr className="text-center">
                <th className="text-left">Moyenne</th>
                <th style={{width: '300px'}} className="text-center">
                  {numeral(table.average).format('0')}
                </th>
              </tr>
              <tr className="text-center">
                <th className="text-left">Nombre total d'utilisateurs</th>
                <th style={{width: '300px'}} className="text-center">
                  {numeral(table.users).format('0')}
                </th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    ) : null;
  };

  return (
    <div id="userConnections-stats-widget">
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title pull-left">
            <i className="fa fa-trophy" /> Challenges par utilisateur
          </h3>
          <br />
        </div>
        <div className="box-body">
          <div className="text-center">
            <div className="inline lang">
              <button
                className={classNames('btn btn-box-tool', {
                  selected: lang === 'fr-FR',
                })}
                onClick={() => setLang('fr-FR')}>
                <span className="flag-icon flag-icon-fr" />
              </button>
            </div>
            <button
              className="ml-2 inline btn btn-default"
              onClick={() =>
                dispatch(getChallengesStats(response => setStats(response)))
              }>
              <i className="fa fa-refresh" />
            </button>
          </div>
        </div>
        {isLoading && <Loader />}
        {renderChallengesByUser()}
      </div>
    </div>
  );
};

export default ChallengesByUser;



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/Stats/components/ChallengesByUser/index.tsx